import get from "lodash.get"

export function getMetadataType(storyMetadata){
    if(!storyMetadata) return ""
    return get(storyMetadata, 'type') || ""
}

export function acceptTap({ tappedIndex, currentWordIndex, phraseLength, lastAdvanceAt, now }) {
    if (tappedIndex !== currentWordIndex + 1) return false;
    if (tappedIndex >= phraseLength) return false;
    // TODO(TT-1005): if revived from backlog, enforce min interval per word from student WCPM + buffer (lastAdvanceAt/now)
    return true;
}
